import { create } from "zustand";

type CoveragePlanStore = {
  /** The plan the user picked; undefined leads with the primary. */
  membershipId?: string;
  select: (membershipId: string) => void;
};

export const useCoveragePlanStore = create<CoveragePlanStore>(set => ({
  membershipId: undefined,
  select: membershipId => set({ membershipId }),
}));
